import { rootApi } from "../../api/rootApi";

export const ecommerceColorsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all colors
    fetchEcommerceColors: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/colors/all`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Add color
    addEcommerceColor: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/colors/add`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),
  }),
});

export const {
  useFetchEcommerceColorsMutation,
  useAddEcommerceColorMutation,
} = ecommerceColorsApi;
